import clsx from 'clsx';
import { Suspense, lazy, memo, useMemo, useState } from 'react';

import { useStorytellerOptions } from '../../store';
import MomentsIdentifier from '../MomentsIdentifier';

import { useEventbus } from '@hooks/useEventbus';
import { useWindowSize } from '@hooks/useWindowSize';

import * as styles from './styles.module.scss';

const StorytellerClipsGridView = lazy(() => import('../StorytellerClipsGridView'));
const StorytellerClipsRowView = lazy(() => import('../StorytellerClipsRowView'));
const StorytellerStoriesGridView = lazy(() => import('../StorytellerStoriesGridView'));
const StorytellerStoriesRowView = lazy(() => import('../StorytellerStoriesRowView'));

const Main = () => {
  const {
    options: { viewTypeDesktop, viewTypeMobile, collectionId, showMomentsIdentifier, className },
  } = useStorytellerOptions();
  const { isMobile } = useWindowSize();
  const [refreshKey, setRefreshKey] = useState(0);
  const [hasError, setHasError] = useState(false);

  const viewType = isMobile ? viewTypeMobile : viewTypeDesktop;

  useEventbus(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, 'storyteller-refresh');

  const handleError = () => {
    setHasError(true);
  };

  const Component = useMemo(() => {
    if (collectionId) return viewType === 'row' ? StorytellerClipsRowView : StorytellerClipsGridView;
    return viewType === 'row' ? StorytellerStoriesRowView : StorytellerStoriesGridView;
  }, [collectionId, viewType]);

  if (hasError) return null;

  return (
    <div key={refreshKey} className={clsx(!collectionId && styles.wrapper, className)}>
      <div className='pk-col pk-col--span-12'>
        {showMomentsIdentifier && <MomentsIdentifier />}
        <div className='story-view'>
          <Suspense>
            <Component onError={handleError} />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default memo(Main);
